export default function highlightMatches(searchedBlock, filter) {

    searchedBlock.querySelectorAll('.highlight').forEach(el => {
        el.outerHTML = el.textContent;
    });

    const $titleElement = searchedBlock.querySelector('.wikiPage__infoBlockTitle');
    if ($titleElement) {
        const regex = new RegExp(`(${filter})`, 'gi');
        $titleElement.innerHTML = !filter
            ? $titleElement.textContent.replace(regex, '<span class="">$1')
            : $titleElement.textContent.replace(regex, '<span class="wiki-search-highlight wiki-search-highlight--block">$1</span>');
    }
    const wikiInfoLinks = searchedBlock.querySelectorAll('.wikiPage__infoLink');
    wikiInfoLinks.forEach(link => {
        const regex = new RegExp(`(${filter})`, 'gi');
        link.innerHTML = !filter
            ? link.textContent.replace(regex, '<span class="">$1</span>')
            : link.textContent.replace(regex, '<span class="wiki-search-highlight wiki-search-highlight--item">$1</span>');
    });
}
